var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"login-container",attrs:{"md":"6","offset":"3"}},[_c('div',{staticClass:"logo-container full-width"},[_c('img',{attrs:{"src":"static/img/basic/boom_logo.png","alt":""}})]),_vm._v(" "),_c('amplify-authenticator',{staticClass:"authenticator",attrs:{"authConfig":_vm.authConfig}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5edd469e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SignIn.vue
// module id = null
// module chunks = 